export function SellsTopCategoriesData(data) {

    return {
        labels: data.labels,
        datasets: [{
            label: 'Total Ventas',
            data: data.data,
            backgroundColor: [
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#FF6384',
                '#36A2EB'
            ],
            hoverBackgroundColor: [
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#FF6384',
                '#36A2EB'
            ]
        }]
    };
}

export function SellsTopCategoriesOptions() {
    return {
        title: {
            display: false,
        },
        legend: {
            display: false,
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                }
            }],
            xAxes: [{
                ticks: {
                    maxRotation: 90
                }
            }]
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsTopCategories/_charts.js